<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item v-for="item in menuItems" :key="item.href" :href="item.href">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Food Trailers and Trucks </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn icon v-for="item in menuItems" :key="item.href" :href="item.href">
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>

      <v-btn icon @click="logout" v-if="user.id != ''" href="/">
        <v-icon>logout</v-icon>
      </v-btn>
      <v-btn v-if="user.id == ''" href="/login">
        Login
      </v-btn>

      <v-btn v-if="user.id == ''" href="/signup">
        SignUp
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from './router'
export default {
  name: 'App',
  components: {},
  created() {
    document.title = 'Food Trailers and Trucks'
  },
  // created() {
  //   window.addEventListener('beforeunload', this.logout())
  // },
  computed: {
    isOpen() {},
    menuItems() {
      return this.allMenuItems.filter(
        item => item.accessUsersType == 'all' || item.accessUsersType.includes(this.user.type)
      )
    },
    ...mapGetters('user', ['user'])
  },
  methods: {
    ...mapActions('user', ['logout'])
  },
  data: () => ({
    drawer: null,

    allMenuItems: [
      {
        href: '/',
        icon: 'shopping_cart',
        title: 'Orders',
        accessUsersType: ['admin']
      },
      {
        href: '/fields',
        icon: 'settings',
        title: 'Fields',
        accessUsersType: ['admin']
      }
    ]
  })
}
</script>

<style lang="scss" scoped></style>
